(function ($) {
    $(function () {

        var objectGallery = $('.images-gallery');

        if (!$(objectGallery).length) {
            return;
        }

        $('.images-gallery').wrap('<div class="images-gallery-c"></div>');

        var productGalleryContainer = $('.images-gallery-c');

        var currentImageContainer = $('<div class="current-image-container"><div class="wrapper"></div></div>');

        $(currentImageContainer).insertBefore(objectGallery);

        var c = 1;
        var imagesLi = $(objectGallery).find('li');

        if ($(imagesLi).length < 2) {
            $('.images-gallery-c').addClass('one-image-only');
        }


        $(imagesLi).each(function () {
            var imgEl = $(this).find('img');
            var imgA = $(this).find('a');
            var imgThumb = $(imgEl).attr('src');
            var imgLarge = $(imgA).attr('href');

            $(imgA).css('background-image', 'url("' + imgThumb + '")').attr('data-large-src', imgLarge).attr('data-image-nr', c++);
            $(imgEl).css('display', 'none');
        });

        var currentImage;


        $(objectGallery).find('li a').on('click', function (e) {
            var largeImage = $(this).data('large-src');

            currentImage = $(this).data('image-nr');

            $(currentImageContainer).css('background-image', 'url("' + largeImage + '")');

            $(objectGallery).find('li a').removeClass('active');
            $(this).addClass('active');

            e.preventDefault();
            return false;
        })
            .first().trigger('click');


        $('.hidden-gallery-images').slickLightbox({
            src: 'href',
            caption: '',
            itemSelector: 'a'
        });

        $('.product-images-zoom, .current-image-container').on('click', function () {
            openLightbox();
        });

        function openLightbox() {
            $('.hidden-gallery-images div:nth-child(' + currentImage + ') a').trigger('click');
        }

        $(objectGallery).addClass('adjusted');
    });
})(jQuery);